import * as React from "react";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PressableProps} from "../../../common/props/PresableProps";
import {FocusableProps} from "../../../common/props/FocusableProps";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import Utility from "../../../../model/utility/Utility";
import {Option} from "ts-option";
import SelectUtility from "./SelectUtility";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import {ClearableProps} from "../../../common/props/ClearableProps";
import {connect} from "react-redux";
import {fetchUtilities} from "../../../../store/action/utility/utility";

type Props = FormGroupProps<string> & FocusableProps & PressableProps & PlaceholderProps & ClearableProps & {
	dispatch: any;
};

/**
 * Utility form view group.
 */
class UtilityFormGroup extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		this.props.dispatch(fetchUtilities());
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectUtility placeholder={this.props.placeholder}
								selectedId={this.props.field.value}
								onChanged={this.onChange}
								clearable={this.props.clearable}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed utility.
	 * @param utility
	 */
	onChange(utility: Option<Utility>) {
		this.props.onChange(this.props.field.updateValue(utility.map((u) => u.id)));
	}
}

export default connect()(UtilityFormGroup);
